import { BadgeVariant } from '@tablecheck/tablekit-react';

import { Incident, RawIncident } from 'components/statusPage/types';

export const ACTIVE_MAINTENANCE_STATUSES = ['in_progress', 'verifying'];
export const UNRESOLVED_INCIDENT_STATUSES = [
  'investigating',
  'identified',
  'monitoring'
];
const RESOLVED_INCIDENT_STATUSES = ['resolved', 'postmortem'];

export const getBadgeVariantForStatusPage = (
  alertType: Incident['displayStatus']
): BadgeVariant | undefined => {
  switch (alertType) {
    case 'maintenance':
      return 'info';
    case 'critical':
      return 'error';
    case 'major':
    case 'minor':
      return 'warning';
    case 'resolved':
      return 'success';
    default:
      return 'neutral';
  }
};

export const parseIncident = (
  type: 'incident' | 'maintenance',
  data: RawIncident
): Incident => {
  const latestUpdate = data.incident_updates[0] || {};
  const latestUpdateCreatedAt = latestUpdate.created_at;
  const latestUpdateDisplayAt = latestUpdate.display_at;
  let displayStatus: Incident['displayStatus'] = 'maintenance';

  if (type === 'incident') {
    displayStatus = RESOLVED_INCIDENT_STATUSES.includes(data.status)
      ? 'resolved'
      : data.impact;
  }

  return {
    id: data.id,
    type,
    componentIds: (data.components || []).map((component) => component.id),
    componentName: (data.components || [])[0]?.name || 'None',
    displayStatus,
    impact: data.impact,
    name: data.name,
    shortlink: data.shortlink,
    status: data.status,
    latestUpdate,
    latestUpdateDisplayAt: latestUpdateDisplayAt || latestUpdateCreatedAt
  };
};
